import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';

export default class EnrollmentService {
    /**
    * Enrolls a new policy or account for the current user
    *
    * @param {Object} data enrollment data
    * @param {Object} additionalHeaders additional headers to pass to the backend (e.g. auth)
    * @returns {Promise} the promise from the backend call
    */
    static addEnrollmentRecord(data, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policyEnrollment'), 'addEnrollmentRecord', [data], additionalHeaders);
    }

    static getAuthorizedUsers(data, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policyEnrollment'), 'getAuthorizedUsers', [data], additionalHeaders);
    }

    static getAccessLevelList(additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policyEnrollment'), 'getAccessLevelList', additionalHeaders);
    }

    static getPublishedNotifications(additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policyEnrollment'), 'getPublishedNotifications', [], additionalHeaders);
    }

    static getPublishedNotificationsForPE(additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policyEnrollment'), 'getPublishedNotificationsForPE', [], additionalHeaders);
    }

    static validateEmailAddress(data,additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policyEnrollment'), 'validateEmailAddress', data, additionalHeaders);
    }
    
    static addUser(data,additionalHeaders = {}) {
        data.userName = data.userName.toLocaleLowerCase()
        data.emails = data.emails.map((email) => {
            email.value = email.value.toLocaleLowerCase()
            return email
        })
        return JsonRPCService.send(getProxiedServiceUrl('policyEnrollment'), 'addUser', [data], additionalHeaders);
    }

    static removeUser(data,additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policyEnrollment'), 'removeUser', [data], additionalHeaders);
    }

    static addUserAccess(data,additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policyEnrollment'), 'addUserAccess', data, additionalHeaders);
    }

    static removeAuthority(userName,accountNumber,additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policyEnrollment'), 'removeAuthority', [userName,accountNumber], additionalHeaders);
    }

    static addAuthority(userName,grantedAuthorities,additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policyEnrollment'), 'addAuthority', [userName,grantedAuthorities], additionalHeaders);
    }
    
    static removeUserAccess(data,additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policyEnrollment'), 'removeUserAccess', data, additionalHeaders);
    }

    static updateNotificationAlert(userName, portalOptInItemID,invoiceStreams,additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policyEnrollment'), 'updateNotificationAlert', [userName, portalOptInItemID,invoiceStreams], additionalHeaders);
    }

    static deleteNotificationAlert(userName, portalOptInItemID,additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policyEnrollment'), 'deleteNotificationAlert', [userName, portalOptInItemID], additionalHeaders);
    }

    static refreshSafetyResourcesSSO(additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policyEnrollment'), 'refreshSafetyResourcesSSO', [], additionalHeaders);
    }

    static updatePaperlessOptinSnapshot(userName, paperlessOpted,accountNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policyEnrollment'), 'updatePaperlessOptinSnapshot', [userName, paperlessOpted, accountNumber], additionalHeaders);
    }

    static getUserOptinsSnapshot(userName, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policyEnrollment'), 'getUserOptinsSnapshot', [userName], additionalHeaders);
    }

    static getUser(data, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policyEnrollment'), 'getUser', [data], additionalHeaders);
    }

    static getPaperlessOptinSnapshot(accountNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policyEnrollment'), 'getPaperlessOptinSnapshot', [accountNumber], additionalHeaders);
    }

    static getAccountLevelOptins(userEmail, accountNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policyEnrollment'), 'getAccountLevelOptins', [userEmail, accountNumber], additionalHeaders);
    }

    static getAllAccountLevelOptins(userEmail, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policyEnrollment'), 'getAllAccountLevelOptins', [userEmail], additionalHeaders);
    }

    static updateAccountLevelOptin(userEmail, accountNumber, portalOptInItemID, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policyEnrollment'), 'updateAccountLevelOptin', [userEmail, accountNumber, portalOptInItemID], additionalHeaders);
    }

    static deleteAccountLevelOptin(userEmail, accountNumber, portalOptInItemID, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policyEnrollment'), 'deleteAccountLevelOptin', [userEmail, accountNumber, portalOptInItemID], additionalHeaders);
    }

}
